<template>
  <Header />
  <div class="section container section--md">
  <div class="content">
    <div class="add-customer-type-container">
      <h2>Type</h2>
      <div v-if="!unfoldAccordion && selectedType">
        <div @click="allowToSelectType" v-bind:style="{ 'background-color': selectedType?.type_color?.hex_value || '#FFF' }" class="type-container">
          {{selectedType.name}}
          <img src="../assets/images/arrow_down.svg" />
        </div>
      </div>
      <div v-if="unfoldAccordion">
        <div v-for="(type, index) in types" :key="type.id" @click="selectType(type)" v-bind:style="{ 'background-color': type?.type_color?.hex_value || '#FFF' }" class="type-container">
          {{type.name}}
          <img v-if="index == 0" src="../assets/images/arrow_up.svg" />
        </div>
      </div>
      <h2>Add New Sub-Type</h2>
      <div class="form-group">
        <label class="form-label">Name *
          <input v-model="subTypeName" class="form-control" :class="displayError ? 'form-control-error' : null" @input="validateInput" v-bind:style="{ 'background-color': selectedSubTypeColor?.rgba_value || '#FFF' }">
        </label>
      </div>
      <div v-if="selectedType?.type_color">
        <h2>Select Color</h2>
        <div v-for="(sub_type_color) in selectedType?.type_color?.sub_type_colors" :key="sub_type_color.id" @click="selectSubTypeColor(sub_type_color)" v-bind:style="{ 'background-color': sub_type_color.rgba_value }" class="sub-type-color-container" :class="{'sub-type-color-container--active': selectedSubTypeColor?.id === sub_type_color.id }">{{selectedType.type_color.name}} - {{ sub_type_color.saturation }}</div>
        <div @click="selectSubTypeColor(null)" v-bind:style="{ 'background-color': '#FFF' }" class="sub-type-color-container" :class="{'sub-type-color-container--active': selectedSubTypeColor === null }">Blank</div>

      </div>
      <div class="buttons">
        <p class="error-message" v-if="displayError">{{ displayError }}</p>
        <button
          type="submit"
          class="btn btn--primary"
          :disabled="subTypeName === null || subTypeName == '' || displayError"
          @click="addNewSubType"
        >
          Save
        </button>
        <button @click="cancel" class="btn btn--warning">Cancel</button>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

import Header from '../components/Header.vue';
import api from '../api'
export default {
  name: 'AddCustomerSubType',
  components: {
    Header
  },
  emits: ['customerTypeAdded', 'customerTypeCancel'],
  data() {
    return {
      types: [],
      displayError: false,
      subTypeName: null,
      selectedType: null,
      unfoldAccordion: true,
      selectedSubTypeColor: null,
    }
  },
  props: {
    customerTypes: {
      default: []
    },
  },
  mounted() {
    api.getTypeColors().then(response => {
      this.colors = response.data.records
    })
    api.getCustomerTypes().then(response => {
      this.types = response.data.records
    })
  },
  methods: {
    cancel() {
      this.$router.push('/admin')
    },
    addNewSubType(e) {
      if(!this.selectedType) {
        this.displayError = 'Please select type'
        return
      }
      this.displayError = false;
      e.preventDefault()
      api.createCustomerSubType({ name: this.subTypeName, type_id: this.selectedType.id, sub_type_color_id: this.selectedSubTypeColor?.id }).then(res => {
        console.log(res);
        this.$router.push(`/admin?added_sub_type_id=${res.data.record.id}`)
      })
    },
    validateInput() {
      if (!/^[a-zA-Z\s&\d]*$/.test(this.subTypeName)) {
        this.displayError = 'Please correct sub-type name.'
        return
      }
      this.displayError = false
    },
    setActiveColor(colorId) {
      this.activeColor = colorId
    },
    selectType(type) {
      this.selectedType = type
      this.displayError = false;
      this.unfoldAccordion = false
      this.selectedSubTypeColor = null;
      this.types = this.types.filter((type) => type.id != this.selectedType.id );
      this.types.unshift(this.selectedType);
      this.validateInput()
    },
    selectSubTypeColor(subTypeColor) {
      this.selectedSubTypeColor = subTypeColor;
    },
    allowToSelectType() {
      this.selectedType = null
      this.unfoldAccordion = true
    },
  },
}
</script>
<style scoped>
.sub-type-color-container,
.type-container {
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  height: 40px;
  margin: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
}

.buttons {
  margin-top: 0;
}

.error-message {
  color: red;
}

.form-control-error {
  border: 1px solid #D43F21;
}

.sub-type-color-container--active {
  border: 1px solid black;
}
</style>
